<template>
  <div>
    <Pagination :table-collection="surveysCollection" sorting-field="created">
      <template slot-scope="props">
        <b-table-column field="title" :label="$t('surveyTitle')">
          {{ props.row.title }}
        </b-table-column>
        <b-table-column field="code" :label="$t('code')">
          {{ props.row.code }}
        </b-table-column>
        <b-table-column field="created" :label="$t('created')">
          <span v-if="props.row.created">
            {{ moment(props.row.created.toDate()).format("YYYY-MM-DD") }}
          </span>
        </b-table-column>
        <b-table-column :label="$t('actions')" numeric header-class="has-text-right">
          <!--<b-tooltip
            v-if="props.row.currentQuestion != null"
            :label="$t('surveyInProgress')"
            type="is-primary"
            class="mr-2"
          >
            <b-icon 
              icon="checkbox-blank-circle"
              :type="props.row.currentQuestion != null ? 'is-danger' : 'is-black'" 
            />
          </b-tooltip>-->
          <b-tooltip v-if="props.row.code" :label="$t('surveyLinks')" type="is-dark">
            <b-button
              class="is-pulled-right"
              type="is-small"
              icon-left="checkbox-multiple-blank-outline"
              @click="
                modalSurveyCode = props.row.code;
                modalSurveyId = props.row.id;
                modalActive = true;
              "
            />
          </b-tooltip>
          <b-tooltip v-if="!props.row.closed" class="ml-2" :label="$t('edit')" type="is-dark">
            <b-button
              type="is-small"
              icon-right="pencil"
              :loading="isLoading"
              :disabled="isDisabled"
              @click="
                $router.push({
                  name: 'CreateSurvey',
                  params: {
                    organizationId: $route.params.organizationId,
                    surveyId: props.row.id,
                  },
                })
              "
            />
          </b-tooltip>
          <b-tooltip :label="$t('surveyAdmin')" type="is-dark">
            <b-button
              class="ml-2"
              type="is-small"
              icon-right="play-pause"
              :loading="isLoading"
              :disabled="isDisabled"
              @click="pushToAdmin(props.row.id, props.row.code)"
            />
          </b-tooltip>
          <b-tooltip :label="$t('delete')" type="is-danger">
            <b-button
              class="ml-2 is-danger"
              type="is-small"
              icon-right="delete"
              :loading="isLoading"
              :disabled="isDisabled"
              @click="deleteSurvey(props.row.id)"
            />
          </b-tooltip>
        </b-table-column>
      </template>

      <template slot="top-left">
        <b-button class="is-primary mb-3" icon-left="plus" @click="createSurvey">
          {{ $t("createSurvey") }}
        </b-button>
      </template>
    </Pagination>
    <input ref="copyText" v-model="copyURL" type="hidden" />
    <b-modal
      :active.sync="modalActive"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
    >
      <AdminLinks :survey-code="modalSurveyCode" :survey-id="modalSurveyId" />
    </b-modal>
  </div>
</template>

<script>
import { v4 } from "uuid";
import { functions, db } from "@/firebase";
import Pagination from "@/components/Pagination";
import AdminLinks from "./AdminLinks";
import moment from "moment";

export default {
  name: "SurveysTable",
  components: {
    Pagination,
    AdminLinks,
  },
  props: {
    surveysCollection: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      baseURL: "app.goqonda.io/polling/participate/",
      isLoading: false,
      isDisabled: false,
      selectedCode: "",
      modalSurveyCode: "",
      modalSurveyId: "",
      modalActive: false,
      moment,
    };
  },
  computed: {
    copyURL() {
      return this.baseURL + this.selectedCode;
    },
  },
  methods: {
    createSurvey() {
      this.$router.push({
        name: "CreateSurvey",
        params: {
          surveyId: v4(),
          organizationId: this.$route.params.organizationId,
        },
      });
    },
    copyLink(code) {
      this.selectedCode = code;
      try {
        this.$refs.copyText.setAttribute("type", "text");
        this.$refs.copyText.value = this.copyURL;
        this.$refs.copyText.select();
        document.execCommand("copy");
        this.$buefy.toast.open({
          message: this.$t("copied"),
          type: "is-success",
        });
      } catch (error) {
        this.$buefy.toast.open({
          message: this.$t("notCopied"),
          type: "is-danger",
        });
      }
      this.$refs.copyText.setAttribute("type", "hidden");
    },
    deleteSurvey(key) {
      this.$buefy.dialog.confirm({
        title: this.$t("deleteSurvey"),
        message: this.$t("deleteSurveyInfo"),
        confirmText: this.$t("deleteSurvey"),
        cancelText: this.$t("cancel"),
        type: "is-danger",
        closeOnConfirm: false,
        hasIcon: true,
        onConfirm: async (str, component) => {
          await this.executeDelete(key);
          component.close();
          return;
        },
      });
    },
    async executeDelete(key) {
      try {
        this.isLoading = true;
        this.isDisabled = true;
        let moderationPw = (await db.collection("surveys").doc(key).collection("data").doc("moderationPw").get()).data()
          .moderationPw;
        await functions.httpsCallable("DeleteSurvey")({
          moderationPw: moderationPw,
          surveyId: key,
        });
        this.$buefy.toast.open({
          type: "is-success",
          message: this.$t("surveyDeleted"),
        });
      } catch (error) {
        this.$buefy.toast.open({
          type: "is-danger",
          message: this.$t("surveyCouldNotBeDeleted"),
        });
      } finally {
        this.isLoading = false;
        this.isDisabled = false;
      }
    },
    async pushToAdmin(key, code) {
      let moderationPw = (await db.collection("surveys").doc(key).collection("data").doc("moderationPw").get()).data()
        .moderationPw;
      this.$router.push({
        name: "AdminSurvey",
        params: { surveyCode: code, moderationPw: moderationPw },
      });
    },
  },
};
</script>

<style></style>
